const MessageBoxPlugin = {
    install (Vue) {
        const prototype = Vue.prototype;
        prototype.$confirm = function (confirmMessage, title = 'Confirm', okText = 'Yes', cancelText = 'No', variant = '', options = {}) {
            if (typeof variant === 'object') {
                options = variant;
            } else {
                options = {
                    ...options,
                    headerBgVariant: variant,
                    okVariant: variant
                };
            }

            return this.$bvModal.msgBoxConfirm(confirmMessage, {
                ...options,
                title: title,
                okTitle: okText,
                cancelTitle: cancelText
            });
        };

        prototype.$confirmSuccess = function (confirmMessage, title = 'Confirm', okText = 'Yes', cancelText = 'No', options = {}) {
            return this.$confirm(confirmMessage, title, okText, cancelText, {
                ...options,
                headerBgVariant: 'success',
                okVariant: 'success'
            });
        };

        prototype.$confirmWarning = function (confirmMessage, title = 'Confirm', okText = 'Yes', cancelText = 'No', options = {}) {
            return this.$confirm(confirmMessage, title, okText, cancelText, {
                ...options,
                headerBgVariant: 'warning',
                okVariant: 'warning'
            });
        };
    }
};

export default MessageBoxPlugin;
